import { ArtifactType } from '@bymason/controller-api-hooks';

export * from './configs';

export const DEFAULT_BOTTOM_SCROLL_THRESHOLD = 150;
export const DEFAULT_PAGE_SIZE = 50;
export const MOVE_DEVICES_MAX_BATCH_COUNT = 500;
export const DEFAULT_GROUPS_QUERY_LIMIT = 500;
export const DEFAULT_GROUP_NAME = 'unassigned';
export const SIGNUP_LEGAL_TEXT = `I agree to receiving information about Mason's products and services, events and other updates which may be of interest to me as described in the Privacy Policy`;
export const XRAY_FEATURE_TARGET = {
  featurePackage: 'com.bymason.platform.core',
  featureCode: 'XRAYV3',
};
export const MASON_OS_DEPLOY_NAME = 'mason-os';
export const DEPLOY_TYPE_MAP = new Map([
  [ArtifactType.Config, 'build'],
  [ArtifactType.Apk, 'app'],
  [ArtifactType.Ota, 'Mason OS update'],
]);

export const STATUS_TOOLTIP_MESSAGES: Record<
  'project' | 'os' | 'apps',
  { updated: string; outOfDate: string }
> = {
  project: {
    updated: `Device’s Mason configuration matches it’s group’s version`,
    outOfDate: `Device's Mason configuration does not match it’s group’s version.`,
  },
  os: {
    updated: `Device’s Mason OS matches it’s group’s version`,
    outOfDate: `Device's Mason OS does not match it’s group’s version. Device’s version may be an older OR more recent version`,
  },
  apps: {
    updated: `Device’s applications match it’s group’s versions`,
    outOfDate: `Device's applications do not match it’s group’s versions`,
  },
};
